<script>
import RbxRemoteCombobox from '../../../shared/reybex/RbxRemoteCombobox';
import RbxRemoteComboboxMultiple from '../../../shared/reybex/RbxRemoteComboboxMultiple';
import RbxExtendedTextarea from '../../../shared/reybex/extendedTextarea/RbxExtendedTextarea';

export default {
  name: 'RequiredDataForm',
  components: {
    RbxRemoteCombobox,
    RbxRemoteComboboxMultiple,
    RbxExtendedTextarea,
  },
  props: {
    procedureDirectory: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      thirdCountryTransferStatusOptions: [{ id: 0, text: 'findet nicht statt und nicht geplant' },
        { id: 1, text: 'findet statt' }, { id: 2, text: 'ist geplant' }],
    };
  },
};
</script>

<template>
  <v-form>
    <v-container fluid grid-list-lg pt-2 pa-0>
      <v-layout row wrap>
        <v-flex xs12 md12>
          <v-textarea
            v-model="procedureDirectory.processingDesc"
            label="Zweckbeschreibung der Verarbeitung"
            class="caption"
          />
        </v-flex>

        <v-flex xs12 md12>
          <rbx-extended-textarea
            v-model="procedureDirectory.legalBasisDesc"
            property-code="procedureDirectory.legalBasisDesc"
            label="Beschreibung der Rechtsgrundlage"
          />
        </v-flex>

        <v-flex xs12 md12>
          <rbx-extended-textarea
            v-model="procedureDirectory.affectedGroupDesc"
            property-code="procedureDirectory.affectedGroupDesc"
            label="Kategorien betroffener Personen"
          />
        </v-flex>

        <v-flex xs12 md12>
          <rbx-extended-textarea
            v-model="procedureDirectory.affectedPersonalDataDesc"
            property-code="procedureDirectory.affectedPersonalDataDesc"
            label="Kategorien der verarbeiteten personenbezogenen Daten"
          />
        </v-flex>

        <v-flex xs12 md12>
          <rbx-extended-textarea
            v-model="procedureDirectory.accessors"
            property-code="procedureDirectory.accessors"
            label="Zugriffsberechtigte Personen"
          />
        </v-flex>

        <v-flex xs12 md3 py-0>
          <v-checkbox
            v-model="procedureDirectory.isPersonalDataSpecial"
            label="Es handelt sich um besondere Arten
            von personenbezogenen Daten (gemäß Art. 9 DSGVO)"
            class="caption"
            hide-details
          />
        </v-flex>

        <v-flex xs12 md3 py-0>
          <v-checkbox
            v-model="procedureDirectory.isExecutedForPrincipal"
            label="Verfahren wird für Auftraggeber ausgeführt"
            class="caption"
            hide-details
          />
        </v-flex>

        <v-flex xs12 md6 py-0>
          <rbx-remote-combobox-multiple
            v-model="procedureDirectory.toms"
            :selected="procedureDirectory.toms"
            searchable
            domain="Tom"
            label="TOMs" />
        </v-flex>

        <v-flex xs12 md12>
          <rbx-extended-textarea
            v-model="procedureDirectory.receivers"
            property-code="procedureDirectory.receivers"
            label="Empfänger oder Kategorien von Empfängern"
          />
        </v-flex>

        <v-flex xs12 md12>
          <rbx-extended-textarea
            v-model="procedureDirectory.sourceOfData"
            property-code="procedureDirectory.sourceOfData"
            label="Beschreibung der Datenherkunft"
          />
        </v-flex>

        <v-flex xs12 md12>
          <rbx-extended-textarea
            v-model="procedureDirectory.deletionPeriod"
            property-code="procedureDirectory.deletionPeriod"
            label="Regelfristen für die Löschung der Daten"
          />
        </v-flex>

        <v-flex xs12 md6 py-0>
          <v-textarea
            v-model="procedureDirectory.dataTransferText"
            label="Datenübermittlung Text"
            class="caption"
          />
        </v-flex>

        <v-flex xs12 md6 py-0>
          <v-select
            :items="thirdCountryTransferStatusOptions"
            v-model="procedureDirectory.thirdCountryTransferStatus"
            item-value="id"
            item-text="text"
            label="Datenübermittlung in Drittstaaten" />
        </v-flex>

        <v-flex xs12 md12>
          <rbx-extended-textarea
            v-model="procedureDirectory.serviceDesc"
            property-code="procedureDirectory.serviceDesc"
            label="Beschreibung der eingesetzten Tools / Dienstleistung"
          />
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>
